'use strict';
angular.module('TurneroApp').component('coModuloCalendario', {
	bindings: {
		readonly: '<',
		datos: '<',
		ctrlPadre: '=',
		modalidad: '<',
		reagendar: '<'
	},
	controller: ['$window', 'turnosService', '$state', 'calendarioService', 'utilsService', 'TurneroAppConstant',
function ($window, turnosService, $state, calendarioService, utilsService, TurneroAppConstant) {
    var ctrl = this;
    ctrl.guardarTurno_data = null;
    ctrl.guardarTurno_anterior = null;
	ctrl.Id_Agenda = '';
	ctrl.Modalidades = TurneroAppConstant.Modalidades;
	ctrl.semanaAnterirorPulsada = false;

	/* ctrl.semanaActual va a tener el lunes de la semana actual. en el caso HOY sea Domingo, le resto 6 dias para obtener el lunes de la semana de HOY
	en caso de que hoy sea un dia de la semana comun, le resto (el numero de dia  - 1 ) que me retorna el lunes de la semana.
	*/
	ctrl.semanaActual = moment(moment(moment().add((moment().toDate().getDay() > 0 ? -(moment().toDate().getDay() - 1) : (-6)), 'days'))).toDate();

	/*
	El objeto semana va a contener datos relacionados a la semana actual del calendario
	ctrl.semana.anterior = fecha de lunes de la semana anterior
	ctrl.semana.siguiente = fecha de lunes de la semana siguiente
	ctrl.semana.primeraFecha = la primer fecha disponible para un turno
	ctrl.semana.Dias = array que contiene las fechas de los dias de la semana de calendario pintado
	ctrl.semana.ultimaFecha es la ultima fecha disponible para un turno
	ctrl.semana.ultimaSemana es la semana de la fecha del ultimo turno
	ctrl.semana.Lunes_Semana_Calendario es la fecha del lunes de la semana que devuelve db, por si fuese diferente del lunes de la semana actual
	*/
	ctrl.semana = {};


	ctrl.regresar = function () {
		ctrl.ctrlPadre.ocultarCalendario(false);
	}

	ctrl.btnAnterior_ocultar = function () {
		if (ctrl.semana.Anterior) {
			if (ctrl.semana.Anterior < moment(ctrl.semanaActual.toDateString()).toDate()) {
				return true;
			}
			if (ctrl.semana.Anterior < moment(ctrl.semana.primeraFecha.toDateString()).toDate()) {
				return true;
			}

			return false;
		}
		return true;
	}


    ctrl.guardarTurno = function (hora, horahasta, fecha) {
        if (!ctrl.readonly) {
            let tieneFechaSeleccionada = ctrl.guardarTurno_anterior != null;
            let fechaSeleccionadaNuevamente = false;

            if (ctrl.guardarTurno_anterior && ctrl.guardarTurno_anterior.dia === fecha && ctrl.guardarTurno_anterior.hora === hora && ctrl.guardarTurno_anterior.horaHasta === horahasta) {
                ctrl.guardarTurno_data = null;
                fechaSeleccionadaNuevamente = true;
            }
            else {
                ctrl.guardarTurno_data = {
                    dia: fecha,
                    hora: hora,
                    horaHasta: horahasta
                };
            }

            angular.forEach(ctrl.CalendarioArmado, function (value, key) {

                if (tieneFechaSeleccionada) {

                    if (value.lunes != null && value.lunes.Fecha == moment(ctrl.guardarTurno_anterior.dia).format('DD/MM/YYYY').toString() && value.lunes.Hora_Desde == ctrl.guardarTurno_anterior.hora && value.lunes.Hora_Hasta == ctrl.guardarTurno_anterior.horaHasta) {
                        value.lunes.esSeleccionado = false;
                    }

                    if (value.martes != null && value.martes.Fecha == moment(ctrl.guardarTurno_anterior.dia).format('DD/MM/YYYY').toString() && value.martes.Hora_Desde == ctrl.guardarTurno_anterior.hora && value.martes.Hora_Hasta == ctrl.guardarTurno_anterior.horaHasta) {
                        value.martes.esSeleccionado = false
                    }

                    if (value.miercoles != null && value.miercoles.Fecha == moment(ctrl.guardarTurno_anterior.dia).format('DD/MM/YYYY').toString() && value.miercoles.Hora_Desde == ctrl.guardarTurno_anterior.hora && value.miercoles.Hora_Hasta == ctrl.guardarTurno_anterior.horaHasta) {
                        value.miercoles.esSeleccionado = false;
                    }

                    if (value.jueves != null && value.jueves.Fecha == moment(ctrl.guardarTurno_anterior.dia).format('DD/MM/YYYY').toString() && value.jueves.Hora_Desde == ctrl.guardarTurno_anterior.hora && value.jueves.Hora_Hasta == ctrl.guardarTurno_anterior.horaHasta) {
                        value.jueves.esSeleccionado = false;
                    }

                    if (value.viernes != null && value.viernes.Fecha == moment(ctrl.guardarTurno_anterior.dia).format('DD/MM/YYYY').toString() && value.viernes.Hora_Desde == ctrl.guardarTurno_anterior.hora && value.viernes.Hora_Hasta == ctrl.guardarTurno_anterior.horaHasta) {
                        value.viernes.esSeleccionado = false;
                    }

                    if (value.sabado != null && value.sabado.Fecha == moment(ctrl.guardarTurno_anterior.dia).format('DD/MM/YYYY').toString() && value.sabado.Hora_Desde == ctrl.guardarTurno_anterior.hora && value.sabado.Hora_Hasta == ctrl.guardarTurno_anterior.horaHasta) {
                        value.sabado.esSeleccionado = false;
                    }

                    if (value.domingo != null && value.domingo.Fecha == moment(ctrl.guardarTurno_anterior.dia).format('DD/MM/YYYY').toString() && value.domingo.Hora_Desde == ctrl.guardarTurno_anterior.hora && value.domingo.Hora_Hasta == ctrl.guardarTurno_anterior.horaHasta) {
                        value.domingo.esSeleccionado = false;
                    }
                }

                if (fechaSeleccionadaNuevamente == false && value.lunes != null && value.lunes.Fecha == moment(fecha).format('DD/MM/YYYY').toString() && value.lunes.Hora_Desde == hora && value.lunes.Hora_Hasta == horahasta) {
                    value.lunes.esSeleccionado = true;
                }

                if (fechaSeleccionadaNuevamente == false && value.martes != null && value.martes.Fecha == moment(fecha).format('DD/MM/YYYY').toString() && value.martes.Hora_Desde == hora && value.martes.Hora_Hasta == horahasta) {
                    value.martes.esSeleccionado = true;
                }

                if (fechaSeleccionadaNuevamente == false && value.miercoles != null && value.miercoles.Fecha == moment(fecha).format('DD/MM/YYYY').toString() && value.miercoles.Hora_Desde == hora && value.miercoles.Hora_Hasta == horahasta) {
                    value.miercoles.esSeleccionado = true;
                }

                if (fechaSeleccionadaNuevamente == false && value.jueves != null && value.jueves.Fecha == moment(fecha).format('DD/MM/YYYY').toString() && value.jueves.Hora_Desde == hora && value.jueves.Hora_Hasta == horahasta) {
                    value.jueves.esSeleccionado = true;
                }

                if (fechaSeleccionadaNuevamente == false && value.viernes != null && value.viernes.Fecha == moment(fecha).format('DD/MM/YYYY').toString() && value.viernes.Hora_Desde == hora && value.viernes.Hora_Hasta == horahasta) {
                    value.viernes.esSeleccionado = true;
                }

                if (fechaSeleccionadaNuevamente == false && value.sabado != null && value.sabado.Fecha == moment(fecha).format('DD/MM/YYYY').toString() && value.sabado.Hora_Desde == hora && value.sabado.Hora_Hasta == horahasta) {
                    value.sabado.esSeleccionado = true;
                }

                if (fechaSeleccionadaNuevamente == false && value.domingo != null && value.domingo.Fecha == moment(fecha).format('DD/MM/YYYY').toString() && value.domingo.Hora_Desde == hora && value.domingo.Hora_Hasta == horahasta) {
                    value.domingo.esSeleccionado = true;
                }
            });

            if (!fechaSeleccionadaNuevamente) {
                ctrl.guardarTurno_anterior = Object.assign({}, ctrl.guardarTurno_data);
            }
        }
	}

	//$onChanges se ejecuta cada vez que los parametros del binging cambian.
	ctrl.$onChanges = function () {
		if (ctrl.datos && ctrl.datos.Agenda && ctrl.datos.Tramite) {
			ctrl.Id_Agenda = ctrl.datos.Agenda.id;
			ctrl.Tramite = ctrl.datos.Tramite.id
			//si el modulo llamador es Presecial le paso el metodo de calendario PRESENCIAL sino (SI es Online el calendario ONLINE sino TELEFONICO)
			//Services va a ser el servicio de get calendario que se va a ejecutar segun la modalidad requerida
			/*Online, Presencial, telefonica*/
			ctrl.Services = {
				Calendario: ctrl.modalidad == ctrl.Modalidades.Presencial ? calendarioService.Get_Calendario : (ctrl.modalidad == ctrl.Modalidades.OnLine ? calendarioService.Get_Calendario_Online : calendarioService.Get_Calendario_Telefonico),
			}
			ctrl.fechaSeleccionada = moment(moment().toDate()).locale('es');
			ctrl.cambiarDia(ctrl.fechaSeleccionada, true);
		}
	}

	ctrl.cambiarDia = function (fecha_param, reload_bool) {
		var fecha = moment(fecha_param, "DD-MM-YYYY")._d;
		if (fecha.getDay() == 0) {
			fecha = moment(moment(fecha).add(-7, 'days')).toDate();
		};

		//Obtengo la fecha del domingo del date picker

		fecha = moment(moment(fecha).add(-(fecha.getDay()), 'days')).toDate();
		//Obtengo la fecha del Lunes de la semana
		var fechaLunes = new Date();
		fechaLunes = moment(moment(fecha).add(1, 'days')).toDate();

        ctrl.guardarTurno_data = null;
		ctrl.obtenerDiasxSemana(fechaLunes, reload_bool);
	}
	ctrl.botonAnterior = function (fechaLunes, cargarNuevamente) {
		ctrl.semanaAnterirorPulsada = true;
		ctrl.obtenerDiasxSemana(fechaLunes, cargarNuevamente);
	};

	ctrl.obtenerDiasxSemana = function (fechaLunes, cargarNuevamente) {
		//con la fecha del lunes de la semana obtengo los dias que siguen hasta el domingo 
		ctrl.semana.Dias = [];
        ctrl.semana.Siguiente = moment(moment(fechaLunes).add(7, 'days')).format('DD/MM/YYYY').toDate();

        ctrl.semana.Anterior = moment(moment(fechaLunes).add(-7, 'days')).format('DD/MM/YYYY').toDate();

		for (var i = 0; i < 7; i++) {
            var fecha = moment(moment(fechaLunes).add(i, 'days')).format('DD/MM/YYYY').toDate();
			//cargo las fechas de la semana
			ctrl.semana.Dias[i] = fecha;
		}
		if (cargarNuevamente) {
			//voy a obtener el calendario
			ctrl.getCalendario(ctrl.Id_Agenda, ctrl.semana.Dias[0]);
		}
	};

	ctrl.mostrarFecha = function (fecha_calendario, fecha) {
		var momentDate = moment(fecha_calendario, 'DD/MM/YYYY')._d;
		if (momentDate.getDate() == fecha.getDate() && momentDate.getMonth() == fecha.getMonth() && momentDate.getYear() == fecha.getYear()) {
			return true;
		}
		return false;
	};

	ctrl.ParseValues = function (value) {
		//recibe el objeto del calendario para un dia y una hora especificada, y verifica si esta, Ocupoado, Bloqueado o disponible. 
		//se utiliza para definir que class se asigna a la celda de calendario. (Llamada desde HTML)
		if (value) {
			if (value.Id_Bloqueo_Calendario) {
				return 'B'; //Bloqueado
			} else if (parseInt(value.Libre) > 0) {
				return 'L';//Disponible
			} else {
				return 'O';//Ocupado
			}
		} else return false;

	}

	ctrl.validarFechaEnSemana = function (fecha) {
		//Verifico si la fecha que devuelve el calendario se encuentra dentro de la semana cargada  : True, sino : False
		var resultado = false;
		for (var i = 0; i < ctrl.semana.Dias.length; i++) {
			if (ctrl.mostrarFecha(moment(fecha).toDate(), ctrl.semana.Dias[i])) {
				resultado = true;
				break;
			}
		}
		return resultado;

	}

	ctrl.getCalendario = function (Id_Agenda, fecha) {
		utilsService.swalNotification('Un momento...', 'Consultando disponibilidad...', 'info');
		ctrl.CalendarioArmado = [];


		ctrl.Services.Calendario({ 'id_agenda': Id_Agenda, 'fecha': moment(fecha).format('DD/MM/YYYY').toDate(), 'Id_Tramite_Relevado': ctrl.Tramite }).$promise.then(function (resultado) {
			try {
				//ultimaFecha es la ultima fecha disponible para un turno
				ctrl.semana.ultimaFecha = moment(moment(resultado.Data.Fecha_Ultimo_Turno)).toDate();
				//primeraFecha : la primer fecha disponible para un turno
				ctrl.semana.primeraFecha = moment(moment(resultado.Data.Fecha_Primer_Turno)).toDate();
				//ultimaSemana: la semana de la fecha del ultimo turno
				ctrl.semana.ultimaSemana = moment(moment(ctrl.semana.ultimaFecha)).toDate();
				//Fecha del lunes de la semana  disponible en calendario
				ctrl.semana.Lunes_Semana_Calendario = moment(moment(resultado.Data.Fecha_Disponible)).toDate();
				//si Lunes_Semana_Calendario se encuentra en las fechas de la semana es porque es la semana cargada
				//sino lo que se hace es obtener las fechas de esa semana
				if (ctrl.validarFechaEnSemana(resultado.Data.Fecha_Disponible)) {
					//se asigna el resultado a ctrl.Calendario
					ctrl.Calendario = resultado.Data;
					if (ctrl.Calendario.Filas.length) {
						//Si el ctrl.Calendario.Filas tiene length es decir tiene valores, vamos a armar el calendario
						ctrl.armadoCalendario(ctrl.Calendario.Filas);
					} else {
						//sino oculta el calendario
						ctrl.regresar();
					}
					ctrl.semanaAnterirorPulsada = false;
				} else {
					if (ctrl.semanaAnterirorPulsada) {
						ctrl.cambiarDia(moment(moment(fecha).add(-7, 'days')).toDate(), true);
					}
					else {
						ctrl.cambiarDia(moment(resultado.Data.Fecha_Disponible), true);
					}
				}
			}
			catch (e) {
				utilsService.errores(e);
			};
		}).catch(function (error) {

			if (error.data.ExceptionMessage && error.data.ExceptionMessage.startsWith('ADV-No hay turnos disponibles')) {
				utilsService.customError('ADV-No hay turnos disponibles para el trámite seleccionado. Intente nuevamente en otro momento.', 'warning', 'Reserva de turnos', ctrl.regresar);
			} else {
				utilsService.errores(error, ctrl.regresar);
			};
		})
	}

	ctrl.armadoCalendario = function (Filas) {
		utilsService.swalNotification('Un momento...', 'Armando calendario...', 'info');
		ctrl.CalendarioArmado = [];
		//La estructura de Filas viene agrupada, es decir los dias que tengan turno para las 08:00hs viene dentro de esa fecha
		for (var i = 0; i < Filas.length; i++) {
			//cada arrayElement es una fila que va desde la hora, pasando por todos los dias de la semana. De lunes a Domingo
			var arrayElement = {
				hora: null,
				lunes: null,
				martes: null,
				miercoles: null,
				jueves: null,
				viernes: null,
				sabado: null,
				domingo: null
			};
			//se asigna la hora desde que es la hora del turno.
			arrayElement.hora = Filas[i].Hora_Desde;
			var arrayElement_Hora_Hasta = arrayElement;
			//aqui voy a obtener los dias que pertenecen a esa hora
			for (var j = 0; j < 7; j++) {
				if (Filas[i] && arrayElement.hora == Filas[i].Hora_Desde) {
					switch (j) {
						case 0: //Lunes
							if (ctrl.mostrarFecha(Filas[i].Fecha, ctrl.semana.Dias[j])) {  //valido que la fecha que estoy enviando sea la del calendario cargado
                                arrayElement.lunes = Filas[i];

                                if (ctrl.guardarTurno_data != null)
                                    arrayElement.lunes.esSeleccionado = (moment(ctrl.guardarTurno_data.dia).format('DD/MM/YYYY').toString() == arrayElement.lunes.Fecha && arrayElement.lunes.Hora_Desde == ctrl.guardarTurno_data.hora && arrayElement.lunes.Hora_Hasta == ctrl.guardarTurno_data.horaHasta);
                                else
                                    arrayElement.lunes.esSeleccionado = false;

                                arrayElement.lunes.Cant_Puestos = Filas[i].Libre + Filas[i].Ocupado;//Calculo de cantidad total de puestos .
								arrayElement.lunes.Cant_Puestos_Array = ctrl.generarArray(arrayElement.lunes.Cant_Puestos, Filas[i].Ocupado);
								i++;
							}
							break;
						case 1: //martes
							if (ctrl.mostrarFecha(Filas[i].Fecha, ctrl.semana.Dias[j])) {
                                arrayElement.martes = Filas[i];

                                if (ctrl.guardarTurno_data != null)
                                    arrayElement.martes.esSeleccionado = (moment(ctrl.guardarTurno_data.dia).format('DD/MM/YYYY').toString() == arrayElement.martes.Fecha && arrayElement.martes.Hora_Desde == ctrl.guardarTurno_data.hora && arrayElement.martes.Hora_Hasta == ctrl.guardarTurno_data.horaHasta);
                                else
                                    arrayElement.martes.esSeleccionado = false;

								arrayElement.martes.Cant_Puestos = Filas[i].Libre + Filas[i].Ocupado;
								arrayElement.martes.Cant_Puestos_Array = ctrl.generarArray(arrayElement.martes.Cant_Puestos, Filas[i].Ocupado);
								i++;
							}
							break;
						case 2: //miercoles
							if (ctrl.mostrarFecha(Filas[i].Fecha, ctrl.semana.Dias[j])) {
                                arrayElement.miercoles = Filas[i];

                                if (ctrl.guardarTurno_data != null)
                                    arrayElement.miercoles.esSeleccionado = (moment(ctrl.guardarTurno_data.dia).format('DD/MM/YYYY').toString() == arrayElement.miercoles.Fecha && arrayElement.miercoles.Hora_Desde == ctrl.guardarTurno_data.hora && arrayElement.miercoles.Hora_Hasta == ctrl.guardarTurno_data.horaHasta);
                                else
                                    arrayElement.miercoles.esSeleccionado = false;

								arrayElement.miercoles.Cant_Puestos = Filas[i].Libre + Filas[i].Ocupado;
								arrayElement.miercoles.Cant_Puestos_Array = ctrl.generarArray(arrayElement.miercoles.Cant_Puestos, Filas[i].Ocupado);
								i++;
							}
							break;
						case 3: //jueves
							if (ctrl.mostrarFecha(Filas[i].Fecha, ctrl.semana.Dias[j])) {
                                arrayElement.jueves = Filas[i];

                                if (ctrl.guardarTurno_data != null)
                                    arrayElement.jueves.esSeleccionado = (moment(ctrl.guardarTurno_data.dia).format('DD/MM/YYYY').toString() == arrayElement.jueves.Fecha && arrayElement.jueves.Hora_Desde == ctrl.guardarTurno_data.hora && arrayElement.jueves.Hora_Hasta == ctrl.guardarTurno_data.horaHasta);
                                else
                                    arrayElement.jueves.esSeleccionado = false;

								arrayElement.jueves.Cant_Puestos = Filas[i].Libre + Filas[i].Ocupado;
								arrayElement.jueves.Cant_Puestos_Array = ctrl.generarArray(arrayElement.jueves.Cant_Puestos, Filas[i].Ocupado);
								i++;
							}
							break;
						case 4: //viernes
							if (ctrl.mostrarFecha(Filas[i].Fecha, ctrl.semana.Dias[j])) {
                                arrayElement.viernes = Filas[i];

                                if (ctrl.guardarTurno_data != null)
                                    arrayElement.viernes.esSeleccionado = (moment(ctrl.guardarTurno_data.dia).format('DD/MM/YYYY').toString() == arrayElement.viernes.Fecha && arrayElement.viernes.Hora_Desde == ctrl.guardarTurno_data.hora && arrayElement.viernes.Hora_Hasta == ctrl.guardarTurno_data.horaHasta);
                                else
                                    arrayElement.viernes.esSeleccionado = false;

								arrayElement.viernes.Cant_Puestos = Filas[i].Libre + Filas[i].Ocupado;
								arrayElement.viernes.Cant_Puestos_Array = ctrl.generarArray(arrayElement.viernes.Cant_Puestos, Filas[i].Ocupado);
								i++;
							}
							break;
						case 5: //sabado
							if (ctrl.mostrarFecha(Filas[i].Fecha, ctrl.semana.Dias[j])) {
                                arrayElement.sabado = Filas[i];

                                if (ctrl.guardarTurno_data != null)
                                    arrayElement.sabado.esSeleccionado = (moment(ctrl.guardarTurno_data.dia).format('DD/MM/YYYY').toString() == arrayElement.sabado.Fecha && arrayElement.sabado.Hora_Desde == ctrl.guardarTurno_data.hora && arrayElement.sabado.Hora_Hasta == ctrl.guardarTurno_data.horaHasta);
                                else
                                    arrayElement.sabado.esSeleccionado = false;

								arrayElement.sabado.Cant_Puestos = Filas[i].Libre + Filas[i].Ocupado;
								arrayElement.sabado.Cant_Puestos_Array = ctrl.generarArray(arrayElement.sabado.Cant_Puestos, Filas[i].Ocupado);
								i++;
							}
							break;
						case 6: //domingo
							if (ctrl.mostrarFecha(Filas[i].Fecha, ctrl.semana.Dias[j])) {
                                arrayElement.domingo = Filas[i];

                                if (ctrl.guardarTurno_data != null)
                                    arrayElement.domingo.esSeleccionado = (moment(ctrl.guardarTurno_data.dia).format('DD/MM/YYYY').toString() == arrayElement.domingo.Fecha && arrayElement.domingo.Hora_Desde == ctrl.guardarTurno_data.hora && arrayElement.domingo.Hora_Hasta == ctrl.guardarTurno_data.horaHasta);
                                else
                                    arrayElement.domingo.esSeleccionado = false;

								arrayElement.domingo.Cant_Puestos = Filas[i].Libre + Filas[i].Ocupado;
								arrayElement.domingo.Cant_Puestos_Array = ctrl.generarArray(arrayElement.domingo.Cant_Puestos, Filas[i].Ocupado);
								i++;
							}
							break;
					}

				}
			}

			//una vez terminado el armado de calendario se sube el elemento al objeto de calendario que va a pintar el calendario en el html
			ctrl.CalendarioArmado.push(arrayElement);
			i = i - 1;
		}

		swal.close();
	}

	ctrl.generarArray = function (cantidad, cantOcupados) {
		var arrayResult = [];
		for (var i = 1; i <= cantidad; i++) {
			var item = {
				id: i,
				ocupado: i <= cantOcupados
			}
			arrayResult.push(item);
		}
		return arrayResult;

	}

    ctrl.siguiente = function () {
        if (ctrl.guardarTurno_data != null) {
            //En este metodo se realizan todas las definiciones para enviar los datos de la fecha y hora del turno seleccionado
            //Si readonly es true es porque se entro en modo visualizacion de calendario
            if (!ctrl.readonly) {                
                if (ctrl.reagendar) {
                    var msn = "El turno <strong>" + ctrl.ctrlPadre.turno.Id_Turno + "</strong> del dia <strong>" + moment(ctrl.ctrlPadre.turno.Turno_Fecha).format("DD/MM") +
                        "</strong> a las <strong>" + moment(ctrl.ctrlPadre.turno.Turno_Fecha).format("HH:mm") + " hs</strong>, se reagenda para el <strong>" + moment(ctrl.guardarTurno_data.dia).format("DD/MM") + "</strong> a las <strong>" + ctrl.guardarTurno_data.hora + " hs</strong>.<br/> ¿Desea continuar?";
                    //"Está reagendando" + ctrl.ctrlPadre.turno.Turno_Fecha + "un turno para el <strong>" + moment(data.dia).format("DD/MM") + "</strong> a las <strong>" + data.hora + " hs</strong>.<br/> ¿Desea continuar?";
                    swal({
                        title: 'Reagendar turno',
                        html: msn,
                        type: 'info',
                        showCancelButton: true,
                        confirmButtonColor: '#004b81',
                        cancelButtonColor: '#971b2f',
                        confirmButtonText: 'Aceptar',
                        cancelButtonText: 'Cancelar',
                        allowEscapeKey: false,
                        allowOutsideClick: false
                    }).then(function () {
                        if (ctrl.guardarTurno_data != null) {
                            //el componente padre tiene esta funcion para finalizar el reagendado
                            ctrl.ctrlPadre.confirmarReagendado(ctrl.guardarTurno_data);
                        }
                    }, function (error) {
                        if (error != 'cancel') {
                            swal.close();
                            utilsService.errores(error)
                        }
                    });
                } else {
                    //el componente padre tiene esta funcion para mostrar la confirmacion
                    ctrl.ctrlPadre.MostrarConfirmacion(ctrl.guardarTurno_data);
                }
            }
        }
    }
}],
	template: require('./Calendario.html')
});



// WEBPACK FOOTER //
// ./app/components/asistencia/CalendarioComponent.js